import { reducerCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { createHandlers } from 'helpers/hotelModuleHelper';
import { actionTypes } from '../actions/hotelNewsletter';

export const DEFAULT_STATE = helper.createDefaultState({
    list: {
        filters: {
            fromId: '',
            lang: null
        }
    }
});

const handlers = createHandlers(actionTypes, {
    items: 'data.results'
});

export default reducerCreator.createReducer(handlers, DEFAULT_STATE);

export const selectors = reducerCreator.createSelectors('hotelNewsletter');
